import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';

export type NotificationInboxView = 'all' | 'unread';

interface NotificationInboxTabsProps {
  value: NotificationInboxView;
  unreadCount: number;
  onValueChange: (value: NotificationInboxView) => void;
  compact?: boolean;
  className?: string;
}

const tabClassName = cn(
  'group flex-none rounded-none border-b-2 border-transparent px-0 text-sm',
  'data-[state=active]:border-primary data-[state=active]:bg-transparent',
  'data-[state=active]:text-foreground data-[state=active]:shadow-none',
);

export function NotificationInboxTabs({
  value,
  unreadCount,
  onValueChange,
  compact = false,
  className,
}: NotificationInboxTabsProps) {
  return (
    <Tabs
      value={value}
      onValueChange={(nextValue) => onValueChange(nextValue as NotificationInboxView)}
      className={className}
    >
      <TabsList
        className={cn(
          'h-auto w-full justify-start rounded-none border-b bg-transparent p-0',
          compact ? 'gap-5' : 'gap-7',
        )}
      >
        <TabsTrigger
          value="all"
          className={cn(tabClassName, compact ? 'h-10' : 'h-11')}
          aria-label="All notifications"
        >
          All
        </TabsTrigger>
        <TabsTrigger
          value="unread"
          className={cn(tabClassName, compact ? 'h-10 gap-1.5' : 'h-11 gap-2')}
          aria-label={
            unreadCount > 0
              ? `Unread notifications, ${unreadCount > 99 ? '99 plus' : unreadCount}`
              : 'Unread notifications'
          }
        >
          Unread
          {unreadCount > 0 && (
            <span className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-muted px-1.5 text-[11px] tabular-nums text-muted-foreground group-data-[state=active]:bg-primary/10 group-data-[state=active]:text-primary">
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
